if (!customElements.get('product-configuration')) {
  customElements.define('product-configuration', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-config-select], [data-config-variant]')) return;
        if (event.target.matches('[data-config-variant]')) {
          const card = event.target.closest('.product-configuration__accessory');
          const input = card.querySelector('[data-config-select]');
          const option = event.target.selectedOptions[0];
          input.dataset.variantId = option.value;
          input.dataset.price = option.dataset.price;
          input.disabled = option.dataset.available !== 'true';
          if (input.disabled) input.checked = false;
          card.querySelector('[data-accessory-price]').textContent = Shopify.formatMoney(Number(option.dataset.price), window.money_format);
        }
        this.closest('product-info')?.querySelector('.quantity__input')?.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: this.controller.signal });
    }
    selections() {
      const seen = new Set();
      return [...this.querySelectorAll('[data-config-select]:checked:not(:disabled)')].filter(input => {
        if (seen.has(input.dataset.variantId)) return false;
        seen.add(input.dataset.variantId);
        return /^([0-9]+|demo-[0-9]+)$/.test(input.dataset.variantId) && Number.isSafeInteger(Number(input.dataset.price)) && Number(input.dataset.price) >= 0;
      });
    }
    getSubtotal(quantity) { return this.selections().reduce((total, input) => total + Number(input.dataset.price) * quantity, 0); }
    getItems(quantity) { return this.selections().filter(input => input.dataset.demo !== 'true').map(input => ({ id: input.dataset.variantId, quantity })); }
    hasTestSelection() { return this.selections().some(input => input.dataset.demo === 'true'); }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
